module.exports = __webpack_public_path__ + "static/media/mic-check-3.85efe317.png";